import React, { useState } from "react";
import { useAuthState } from "react-firebase-hooks/auth";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import auth from "../../firebase.init";
import Loading from "../Shared/Loading";

const AddBrand = () => {
  const [user, userLoading] = useAuthState(auth);
  const {
    register,
    formState: { errors },
    handleSubmit,
    reset,
  } = useForm();
  const [loading, setLoading] = useState(false);

  if (userLoading || loading) {
    return <Loading></Loading>;
  }

  const imageStorageKey = "c4016c785641be139f6ea8c30408feed";

  const onSubmit = async (data) => {
    // console.log(data);
    setLoading(true);

    const image = data.brand_image[0];
    const formData = new FormData();
    formData.append("image", image);
    const url = `https://api.imgbb.com/1/upload?key=${imageStorageKey}`;
    const res = await fetch(url, {
      method: "POST",
      body: formData,
    });
    const result = await res.json();
    if (result) {
      // console.log(result);
      if (result.success) {
        const img = result.data.url;
        const brand = {
          brand_name: data.brand_name,
          brand_image: img,
          brand_slug: data.brand_slug,
        };
        const response = await fetch(
          `https://evening-peak-35730.herokuapp.com/brand/${user?.email}`,
          {
            method: "POST",
            headers: {
              "content-type": "application/json",
              authorization: `Bearer ${localStorage.getItem("accessToken")}`,
            },
            body: JSON.stringify(brand),
          }
        );
        const result2 = await response.json();
        if (result2) {
          setLoading(false);
          if (!result2.success) {
            toast.error(result2?.message);
          } else {
            const updateTotalDataStatus = { status: "increaseBrands" };
            const response3 = await fetch(
              `https://evening-peak-35730.herokuapp.com/updateTotalProductsAndBrands/${user?.email}`,
              {
                method: "PUT",
                headers: {
                  "content-type": "application/json",
                  authorization: `Bearer ${localStorage.getItem(
                    "accessToken"
                  )}`,
                },
                body: JSON.stringify(updateTotalDataStatus),
              }
            );
            const result3 = await response3.json();
            if (result3) {
              toast.success("Brand Added Successfully. ALhamdulillah!!");
            } else {
              toast(
                "Brand Added Successfully. ALhamdulillah!!. But total Brands doesn't update!!!"
              );
            }
          }
          reset();
        }
      }
    }
  };

  return (
    <div>
      <h1 className="text-xl text-accent text-center my-4 font-bold">
        Add A New Brand
      </h1>
      <div className="card bg-primary py-5">
        <div className="card-body">
          <form
            onSubmit={handleSubmit(onSubmit)}
            className="w-100 md:w-6/12 mx-auto"
          >
            <div className="form-control mt-3">
              <label className="label">
                <span className="label-text text-white font-bold">
                  Brand's Name
                </span>
              </label>
              <input
                type="text"
                placeholder="brand's name"
                className="input input-bordered text-primary"
                {...register("brand_name", {
                  required: {
                    value: true,
                    message: "Brand's name is required.",
                  },
                })}
              />
              <label className="label">
                {errors.brand_name?.type === "required" && (
                  <span className="label-text-alt font-bold text-error">
                    {errors.brand_name.message}
                  </span>
                )}
              </label>
            </div>
            <div className="form-control mt-3">
              <label className="label">
                <span className="label-text text-white font-bold">
                  Brand's Image
                </span>
              </label>
              <input
                type="file"
                placeholder="brand's image"
                className="input-bordered text-white"
                {...register("brand_image", {
                  required: {
                    value: true,
                    message: "Brand's image is required.",
                  },
                })}
              />
              <label className="label">
                {errors.brand_image?.type === "required" && (
                  <span className="label-text-alt font-bold text-error">
                    {errors.brand_image.message}
                  </span>
                )}
              </label>
            </div>
            <div className="form-control mt-3">
              <label className="label">
                <span className="label-text text-white font-bold">
                  Brand's Slug
                </span>
              </label>
              <input
                type="text"
                placeholder="brand's slug"
                className="input input-bordered text-primary"
                {...register("brand_slug", {
                  required: {
                    value: true,
                    message: "Brand slug is required.",
                  },
                })}
              />
              <label className="label">
                {errors.brand_slug?.type === "required" && (
                  <span className="label-text-alt font-bold text-error">
                    {errors.brand_slug.message}
                  </span>
                )}
              </label>
            </div>
            <div className="form-control mt-6">
              <button className="btn btn-neutral text-primary font-bold">
                Add Brand
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default AddBrand;
